import { gql } from '@apollo/client'

export const COMPANY_CATEGORY_SOVI_FORMULA_GROUPS = gql`
  query CompanyCategorySoviFormulaGroups {
    companyCategorySoviFormulaGroups {
      name
      id
      info
    }
  }
`
